
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { dataService } from "../../../services/data.services";


const initialState = {
    loading: true,
    error: '',
    success: '',
}
export const FinancialYearResult = createAsyncThunk('financial-year', async (searchParams) => {
    let res = await dataService.GetAPI(searchParams);
    return res
})
const FinancialYearSlice = createSlice({

    name: 'financial-year',
    initialState,
    reducers: {
        setLoading: (state, action) => {
            state.loading = true
        }

    },
    extraReducers: {
        [FinancialYearResult.pending]: (state) => {
            state.loading = true
            state.error = null
        },
        [FinancialYearResult.fulfilled]: (state, action) => {
            state.loading = false;
            if(!action?.payload?.error && action?.payload?.data.status===200){
                state.List=action?.payload?.data.data;
                
            }else{
                state.error=action?.payload?.data?.message
            }
        },
        [FinancialYearResult.rejected]: (state, { payload }) => {
            state.loading = false
            state.error = payload?.message?.message
        },
    },
})
export const { setLoading } = FinancialYearSlice.actions;
export default FinancialYearSlice.reducer